import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { GetTickets } from "../../Apis/AuthApiServices";
import { loadingTickets, setTickets } from "../Slice/GetTicketsSlice";

function* onLoadTicketsAsync({ payload }: any) {
  const params = new URLSearchParams();
  let LoginUserID: any = localStorage.getItem("LoginUserID");
  params.append("userId", LoginUserID);
  params.append("pageNumber", payload.pageNumber);
  try {
    const result: AxiosResponse = yield GetTickets(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setTickets({
          AllTicketsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setTickets({
          AllTicketsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setTickets({
        AllTicketsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadTickets() {
  yield takeLatest(loadingTickets.type, onLoadTicketsAsync);
}

const TicketsSaga = [fork(onLoadTickets)];
export default TicketsSaga;
